var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8068 1.3804C18.6705 1.61917 19.3523 2.30081 19.5795 3.16458C20 4.73294 20 8.0054 20 8.0054C20 8.0054 20 11.2784 19.5909 12.8462C19.3523 13.7212 18.6818 14.4034 17.8182 14.6304C16.25 15.0508 10 15.0508 10 15.0508C10 15.0508 3.75 15.0508 2.19318 14.6304C1.32953 14.3916 0.647705 13.71 0.420471 12.8462C0 11.2784 0 8.0054 0 8.0054C0 8.0054 0 4.73294 0.409119 3.16458C0.647705 2.28958 1.31818 1.60794 2.18182 1.3804C3.75 0.959991 10 0.959991 10 0.959991C10 0.959991 16.25 0.959991 17.8068 1.3804ZM7.95459 5.02835V10.9829L13.1819 8.0054L7.95459 5.02835Z",
    fill: "#B3B3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.fd6bbd24814c70e60ddf065c737c8a37.svg";
export { ForwardRef as ReactComponent };